<template>
    <div class="content d-flex align-center justify-center">
        <img src="@/assets/geodis/logo_white.png" />
        <v-form @submit.prevent>
            <v-text-field
                color="#3200E6"
                v-model="fields.geodisLogin"
                :label="$t('login.username')"
                :persistent-hint="true"
                :hint="hintError"
                :placeholder="!autofilled ? ' ' : ''"
                data-cy="loginInput"
            ></v-text-field>
            <v-text-field
                color="#3200E6"
                v-model="fields.password"
                :label="$t('login.password')"
                :persistent-hint="true"
                :hint="hintError"
                :append-icon="showPwd ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                @click:append="() => (showPwd = !showPwd)"
                :type="showPwd ? 'password' : 'text'"
                @keyup.enter.native="submit"
                data-cy="pwdInput"
            ></v-text-field>
            <div class="actions d-flex">
                <v-btn :disabled="!fields.geodisLogin || !fields.password" class="action" @click="submit" data-cy="loginSubmit">
                    {{ $t('login.signin') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="secondary-action" @click="clear" data-cy="loginCancel">
                    {{ $t('login.cancel') }}
                </v-btn>
            </div>
            <div>
                <router-link to="/password-lost" data-cy="passwordLost">
                    {{ $t('login.passwordLost') }}
                </router-link>
            </div>
        </v-form>
    </div>
</template>

<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt';
import { api } from '@utils/api';
import { i18n } from '@plugins/vuetify';
import { mapMutations } from 'vuex';
import { ACLCONFIG, SET_USER_ROLES } from '@constants/aclConfig';
import { pubKey } from '@constants/pubKey';

export default {
    data() {
        return {
            autofilled: null,
            showPwd: 'password',
            hintError: '',
            fields: {
                geodisLogin: null,
                password: null
            }
        };
    },
    methods: {
        ...mapMutations(ACLCONFIG, [SET_USER_ROLES]),
        getUserRoles: async function () {
            const groups = await api.get(
                'getconfigroles',
                null,
                {
                    withCredentials: true
                },
                'admin'
            );
            await this.setUserRolesAndAuthorization(groups);
        },
        async submit() {
            const encryptor = new JSEncrypt();
            encryptor.setPublicKey(pubKey);
            const password = encryptor.encrypt(this.fields.password);

            const res = await api.post('login', { geodisLogin: this.fields.geodisLogin, password }, null, 'admin');
            if (res && res.message === 'login succeed') {
                await this.getUserRoles();
                window.location.href = window.location.origin;
            } else {
                this.hintError = i18n.t('login.hintError');
            }
        },
        clear() {
            this.fields.geodisLogin = this.fields.password = null;
        }
    },
    watch: {
        'fields.geodisLogin'() {
            this.autofilled = true;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.content {
    height: 100%;
    background-color: $primary;
    > img {
        position: absolute;
        width: 100px;
        top: 20px;
        left: 20px;
    }
}

.actions {
    margin: 10px 0 20px;
}

form {
    background-color: #fff;
    width: 300px;
    padding: 40px;
    text-align: center;
}
</style>
